import styled from "styled-components";
import { BREAKPOINTS } from "../../../app/appConstants";

export const RespawnPositionsStyled = styled.div`
    margin-bottom: 24px;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin-bottom: 16px;
    }

    .accordion {
        border: 1px solid var(--color-background-secondary);
        background: var(--color-background-tertiary);
        border-radius: var(--border-radius);

        :hover {
            border-color: var(--color-background-secondary);
        }
    }

    .accordion-body {
        padding: 0 0 8px;
    }

    .accordion-item {
        @media (max-width: ${BREAKPOINTS.medium}px) {
            border-radius: 0;
        }

        &:last-of-type .accordion-collapse {
            border-radius: 0;
        }
    }

    .accordion-button {
        font-weight: 400;
        font-size: 16px;
        background: var(--color-background-tertiary);

        @media (max-width: ${BREAKPOINTS.medium}px) {
            font-size: 14px;
            padding: 16px;
            .badge {
                display: none;
            }
        }

    }

    .flex-row {
        width: 100%;
    }

    .position-header {
        color: var(--color-white-60);
        font-size: 12px;
        text-align: left;
        padding: 8px 24px;
        border-top: 1px solid var(--color-surface);
        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding: 8px 16px;
        }
    }

    .position-row {
        padding: 16px 24px;
        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding: 8px 16px;
        }
    }

    .symbol {
        font-size: 14px;
    }

    .side {
        font-size: 14px;
        margin-left: 4px;
    }

    .pl-title {
        color: var(--color-secondary);
    }

    .pl {
        font-size: 14px;
        padding-left: 4px;
    }
`;